/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Account_1Inputs */

const da_terms_account_1 = /** @type {(inputs: Terms_Account_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontoen er personlig. Du skal holde din adgangskode hemmelig og må kun uploade materiale, du har ret til at bruge. Elevernes navne skal dækkes, før besvarelser uploades. AImforA hjælper med at finde dem, men du skal selv se efter, at de er dækket.`)
};

/** @type {(inputs: Terms_Account_1Inputs) => LocalizedString} */
const en_terms_account_1 = da_terms_account_1;

/**

* @param {Terms_Account_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_account_1 = /** @type {((inputs?: Terms_Account_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Account_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_account_1(inputs)
	return /** @type {LocalizedString} */ ("Kontoen er personlig. Du skal holde din adgangskode hemmelig og må kun uploade materiale, du har ret til at bruge. Elevernes navne skal dækkes, før besvarelser uploades. AImforA hjælper med at finde dem, men du skal selv se efter, at de er dækket.")
});